import React from "react";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import CorporateBanner from "./CorporateBanner";
import CorporateItems from "./CorporateItems";

const Corporate = () => {
  return (
    <>
      <Menu header_style_2={true} />
      <CorporateBanner />
      <CorporateItems />
      <FooterThree />
    </>
  );
};

export default Corporate;
